export class GenerateArticleRequest {
    domainId: number;
    sourceArticles: string[];
}
